import { RHFSelect } from "src/components/hook-form";
import Map from "src/components/map";

import { useTranslation } from "react-i18next";
import { countries } from "./countries";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";

const Countries = ({ type = "alpha_3", name,defaultValue , label, ...rest }) => {
  const { t } = useTranslation();
  const { setValue, getValues } = useFormContext();

  const renderer =
    type === "alpha_3"
      ? ({ name, alpha_3 }) => <option value={alpha_3}>{name}</option>
      : ({ name, alpha_2 }) => <option value={alpha_2}>{name}</option>;

      const indiaDefault = type === "alpha_3" ? "IND" : "IN";

      useEffect(() => {
        const currentValue = getValues(name);
        if (!currentValue) {
          setValue(name, defaultValue || indiaDefault);
        }
      }, [name, defaultValue, indiaDefault, setValue, getValues]);
    

  return (
    <RHFSelect
      {...rest}
      name={name ? name : "country"}
      label={label ? label : t("profile.choose_country")}
    >
      <option value="" />
      <Map list={countries} render={renderer} />
    </RHFSelect>
  );
};

export default Countries;
